import { Message } from 'jl-design-system/components/message/Message';
import styles from '~/components/layout/SidebarLayout.scss';

export const CookiesErrorMessage = () => (
  <Message
    title="Your browser is blocking cookies"
    type="warning"
    body="This page needs to run cookies to keep you logged in. Please refresh your page or disable any
      plugins that might be blocking a cookie banner."
    buttonProps={{
      href: 'https://www.johnlewis.com/customer-services/shopping-with-us/cookies',
      rel: 'noopener noreferrer',
      tag: 'a',
    }}
    buttonText="How to enable cookies"
    whiteBackground
    wideTab
    className={styles.message}
  />
);
